import { useLang } from "../i18n";
import { Chapter } from "./Reveal";

export function DueDiligence() {
  const { t } = useLang();
  return (
    <section data-testid="diligence-section" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <Chapter kicker={t.diligence.kicker} title={t.diligence.title} subtitle={t.diligence.subtitle} testId="diligence" />
      </div>
    </section>
  );
}
